"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPassengersToString = transformPassengersToString;
function transformPassengersToString(passengers) {
    const adults = passengers.filter((p) => p.isAdult() || p.isLead());
    const children = passengers.filter((p) => p.isChild());
    return `${adults.length}x ${adults.length > 1 ? "adults " : "adult "}${children.length > 0 ? ` & ${children.length.toString()}x ${children.length > 1 ? "children " : "child "}` : ""}`;
}
//# sourceMappingURL=transformPassengersToString.js.map